import { useEffect } from 'react';
import { Spin } from '@wajeez-web/components/ui';
import {
  ComponentTypesActions,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { useParams } from 'react-router-dom';
import { Server } from '@wajeez/wajeez.microservices';

import { FormSectionTitle } from '../components/FormSectionTitle';
import { fieldTypes } from '../components/ComponentTypeFormBuilder';
import { FieldContent } from '../components/FieldContent';
import { TypeFieldOptionsDataComponents } from '../components/TypeFieldOptionsDataComponents';

export const ComponentTypePage = () => {
  const { id } = useParams<{ id: string }>();

  const contentDispatch = useContentDispatch();

  const componentType = useContentSelector(
    ({ componentTypes }) => componentTypes.componentTypeById
  );
  const componentTypeData = componentType.data;

  useEffect(() => {
    if (id) {
      contentDispatch(
        ComponentTypesActions.getComponentTypeByIdAsync(Number(id))
      );
    }
  }, [id]);

  const isLoading = componentType.status === 'loading';

  const renderFields = () => {
    return componentTypeData?.fields?.map((f, i) => {
      return (
        <div
          key={f.id}
          className="mt-3 w-[650px] p-4 flex justify-between items-center border rounded"
        >
          <div className="w-full">
            <div className="mb-3 text-[17px] font-bold">
              {fieldTypes.find((t) => t.id === f.fieldType)?.name}
            </div>
            <div className="w-full grid grid-cols-2 gap-4">
              <div className="col-span-2">
                <FieldContent
                  label="Required"
                  value={f.required ? 'Yes' : 'No'}
                />
              </div>
              <FieldContent label="Name" value={f.name} />
              <FieldContent label="Label" value={f.label} />
              <FieldContent label="Placeholder" value={f.placeHolder} />
              {f.fieldOptions && (
                <TypeFieldOptionsDataComponents
                  fieldType={f.fieldType}
                  fieldOptions={f.fieldOptions}
                />
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return isLoading ? (
    <div className="w-full">
      <Spin />
    </div>
  ) : (
    <div className="w-full p-8">
      <div className="w-full pb-6 border-b-[2px]">
        <FormSectionTitle sectionNumber={1} title="Basic Information" />
        <div className="w-[400px] flex flex-col justify-start items-start space-y-2">
          <FieldContent label="Name" value={componentTypeData?.name} />
          <FieldContent
            label="Content Type"
            value={
              componentTypeData?.contentItemType === Server.ContentItemType.Item
                ? 'Component'
                : 'Collection Component'
            }
          />
          <FieldContent label="Title" value={componentTypeData?.title} />
          <FieldContent
            label="Description"
            value={componentTypeData?.description}
          />
        </div>
      </div>
      <div className="mt-6">
        <FormSectionTitle sectionNumber={2} title="Dynamic Fields" />
        <div className="mt-3 w-full">{renderFields()}</div>
      </div>
    </div>
  );
};
